import { EditCaseButton, RenderIf } from "..";
import DeleteButtonIcon from "../../assets/icons/DeleteButtonIcon.svg?react";
import DownloadIcon from "../../assets/icons/DownloadIcon.svg?react";
import { CaseSummaryLink } from "../index";
import DemandStudioButton from "../demand-studio/DemandStudioButton";
import LifecareStudioButton from "../demand-studio/LifecareStudioButton";
import useCaseActionControls from "../../hooks/useCaseActionControls";
import Tooltip from "./Tooltip";
import FinalizeCaseLink from "./FinalizeCaseLink";
import ActionButton from "../common/ActionButton";

// Even 2x2 grid of labelled buttons; each cell stretches so the four read as one block.
// Tooltip's wrapper span is collapsed so its button becomes the real grid item.
const gridClasses = `
    grid grid-cols-2
    items-center
    gap-x-action-grid-gap-x gap-y-action-grid-gap-y
    [&>span]:contents
`;

const STUDIO_NOT_READY_MESSAGE = "Generate a demand first to use the studio";

const CaseActionControls = ({ caseData, setCaseIdToDelete, onToggle }) => {
    const { _id } = caseData;
    const {
        isDownloadAvailable,
        isDeleteDisabled,
        isEditDisabled,
        editTooltip,
        isSuggestedEditsUiEnabled,
        isCertifiedLifecareCompany,
        onMarkDemandReady,
        onMarkNoteAdded,
    } = useCaseActionControls(caseData);

    return (
        <div className={gridClasses}>
            <Tooltip title={editTooltip} placement="top">
                <EditCaseButton
                    caseId={_id}
                    variant="actionOutline"
                    text={isCertifiedLifecareCompany ? "View Case" : "Edit Case"}
                    disabled={isEditDisabled}
                    onClick={onMarkDemandReady}
                />
            </Tooltip>
            {isSuggestedEditsUiEnabled && (
                <>
                    <RenderIf shouldRender={isCertifiedLifecareCompany}>
                        <Tooltip title={isDownloadAvailable ? "Edit the life care plan" : STUDIO_NOT_READY_MESSAGE} placement="top">
                            <LifecareStudioButton caseId={_id} disabled={!isDownloadAvailable} onClick={onMarkDemandReady} />
                        </Tooltip>
                    </RenderIf>
                    <RenderIf shouldRender={!isCertifiedLifecareCompany}>
                        <Tooltip title={isDownloadAvailable ? "Edit AI generated sections of your demand" : STUDIO_NOT_READY_MESSAGE} placement="top">
                            <DemandStudioButton caseId={_id} disabled={!isDownloadAvailable} onClick={onMarkDemandReady} />
                        </Tooltip>
                    </RenderIf>
                </>
            )}
            <RenderIf shouldRender={!isDownloadAvailable}>
                <ActionButton
                    variant='actionOutline'
                    icon={DeleteButtonIcon}
                    label="Delete"
                    disabled={isDeleteDisabled}
                    onClick={() => setCaseIdToDelete(_id)}
                    tooltipTitle="Delete Case"
                />
            </RenderIf>
            <RenderIf shouldRender={isDownloadAvailable}>
                <ActionButton
                    variant='actionOutline'
                    icon={DownloadIcon}
                    label="Downloads"
                    onClick={() => { onToggle(_id); onMarkDemandReady(); }}
                    tooltipTitle="Download demand letters and other case documents"
                />
            </RenderIf>
            {isCertifiedLifecareCompany ? (
                <FinalizeCaseLink caseId={_id} onClick={onMarkDemandReady} />
            ) : (
                <Tooltip title="View key case details and settlement information" placement="top">
                    <CaseSummaryLink caseId={_id} hideOnInit={false} onClick={onMarkNoteAdded} />
                </Tooltip>
            )}
        </div>
    );
};

export default CaseActionControls;
